// extracted by mini-css-extract-plugin
export default {"statValue":"BulkUploadBriefModal_statValue__Me-BA"};